import React, { useEffect } from 'react'
import './App.css'
import PdfGenerator from './pages/PdfGenerator'

const App = () => {
  useEffect(() => {
    const allowedOrigins = [
      'https://administration.oqm-business.com',
      'https://administration.dev.oqm-business.com',
      'https://survey.oqm-business.com',
      'https://survey.dev.oqm-business.com',
      'https://oqm-pdf-generator-ed22e486ca37.herokuapp.com',
      'http://localhost:3000',
      'http://localhost:3001',
      'http://localhost:3002',
    ];

    const messageHandler = (event) => {
      console.log('Received message from origin:', event.origin);
      if (!allowedOrigins.includes(event.origin)) {
        console.warn('Invalid origin:', event.origin);
        return;
      }
      if (event.data === 'getStatus') {
        console.log('Valid origin. Sending status back.');
        event.source.postMessage({ status: 'ready' }, event.origin);
      }
    };

    window.addEventListener('message', messageHandler);

    return () => {
      window.removeEventListener('message', messageHandler);
    };
  }, []);

  return (
    <>
      {<PdfGenerator />}
    </>
  );
};

export default App